module.exports = __webpack_public_path__ + "img/bg_box_bottom.98318c51.png";